import React, { useMemo } from 'react';
import { Typography, ConfirmationModal } from 'seagull';
import { AdvancedSettingsControl } from "../ServiceAdvancedSettings/AdvancedSettingsControl/AdvancedSettingsControl";
import { AdvancedSettingCategory, ADVANCED_SETTING_CATEGORY_MAP } from "../ServiceAdvancedSettings/ServiceAdvancedSettings.types";
import styles from "./ServiceAdvancedSettingsModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ServiceAdvancedSettingsModal = _ref => {
  let {
    onClose,
    testId,
    availableSettings
  } = _ref;
  const settingsByCategory = useMemo(() => {
    const grouped = {
      [AdvancedSettingCategory.Pricing]: [],
      [AdvancedSettingCategory.Billing]: [],
      [AdvancedSettingCategory.Integrations]: []
    };
    availableSettings.forEach(setting => {
      const category = ADVANCED_SETTING_CATEGORY_MAP[setting.type];
      grouped[category].push(setting);
    });
    return grouped;
  }, [availableSettings]);
  const categories = [AdvancedSettingCategory.Pricing, AdvancedSettingCategory.Billing, AdvancedSettingCategory.Integrations];
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Advanced settings",
    onCloseButtonClick: onClose,
    "data-testid": testId ? "".concat(testId, "-adv-settings-modal") : 'adv-settings-modal',
    width: "600px",
    content: /*#__PURE__*/_jsx(_Fragment, {
      children: categories.map(category => {
        const settings = settingsByCategory[category];
        if (settings.length === 0) return null;
        return /*#__PURE__*/_jsxs("div", {
          className: styles.category,
          "data-testid": testId ? "".concat(testId, "-adv-settings-modal-category-").concat(category) : undefined,
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "secondary",
            children: category
          }), settings.map(setting => /*#__PURE__*/_jsx(AdvancedSettingsControl, {
            isReadOnly: false,
            info: setting.info,
            label: setting.label,
            checked: false,
            testid: testId ? "".concat(testId, "-adv-settings-modal-setting-").concat(category, "-").concat(setting.type) : undefined,
            disabled: setting.disabled,
            disabledTooltip: setting.disabledTooltip,
            onChange: () => {}
          }, setting.type))]
        }, category);
      })
    })
  });
};